import axios from 'axios';

const apiClientCoinGecko = axios.create({
    baseURL:"https://api.coingecko.com/api/v3",
    params:{
        "x-cg-demo-api-key":"CG-f3NRFVDm5xQH5Cvv6GBWEH78",
        "accept":"application/json"
    }
})

export default apiClientCoinGecko;